export class DocumentConstant {
  static readonly SUCCESS: string = "Uploaded";
  static readonly FAILED: string = "Failed";
}
